module.exports = __webpack_public_path__ + "static/media/0026_IMG_LE_BOUCHER.167c07cd.webp";